import { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { usePracticeOutbox } from '../api/use-practice-outbox.js';
import { practiceWords } from '../components/practice-words.js';

/**
 * The Done screen (board R3, approved): Swings, Time, Type and Notes. The swings
 * and time are already saved when this opens, so nothing here is required.
 * Clips join it in stage 4.
 */

const TYPES = practiceWords.types;

export function PracticeDoneRoute() {
  const { practiceId } = useParams();
  const navigate = useNavigate();
  const outbox = usePracticeOutbox();
  const [practice] = useState(() => outbox.find(practiceId ?? ''));
  const [types, setTypes] = useState<string[]>([]);
  const [notes, setNotes] = useState('');

  if (!practice) return <Navigate to="/tools" replace />;

  const minutes = Math.round((Date.parse(practice.lastSwingAt) - Date.parse(practice.firstSwingAt)) / 60000);

  function done() {
    if (practice) outbox.finish(practice.id, TYPES.map(([code]) => code).filter((code) => types.includes(code)), notes);
    navigate('/tools', { replace: true });
  }

  return (
    <main className="practice-done">
      <h2>Practice · {practiceWords.day(practice.practiceDate)}</h2>
      <div className="practice-figures">
        <div>
          <span className="practice-label">Swings</span>
          <span className="practice-figure">{practice.swingCount}</span>
        </div>
        <div>
          <span className="practice-label">Time</span>
          <span className="practice-figure">{minutes} min</span>
        </div>
      </div>
      <span className="practice-label" id="practice-type">
        Type
      </span>
      <div className="practice-types" role="group" aria-labelledby="practice-type">
        {TYPES.map(([code, label]) => (
          <button
            key={code}
            type="button"
            aria-pressed={types.includes(code)}
            onClick={() => setTypes((now) => (now.includes(code) ? now.filter((each) => each !== code) : [...now, code]))}
          >
            {label}
          </button>
        ))}
      </div>
      <label className="practice-label" htmlFor="practice-notes">
        Notes
      </label>
      <textarea id="practice-notes" maxLength={2000} value={notes} onChange={(event) => setNotes(event.target.value)} />
      <button type="button" className="primary" onClick={done}>
        Done
      </button>
    </main>
  );
}
